import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";

export const useGetIngredient = (
    queryKey: string | (string | number)[],
    ingredientId: string,
    options?: { enabled?: boolean; keepPreviousData?: boolean },
): UseQueryResult<types.IIngredient> => {
    const auth = useAuth();

    return useQuery<types.IIngredient>(
        queryKey,
        async () => {
            if (!auth.token) {
                throw new Error("Cannot fetch without authorization token.");
            }
            return await api.Ingredients.get(ingredientId, auth.token);
        },
        options,
    );
};
